import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { device } from '../breakpoints'

const Header = ({
  title,
  text,
  sup,
  tenant,
}: {
  title: string
  text: string
  sup: string
  tenant: Tenant | undefined
}) => {
  return (
    <Container>
      <TextWidth>
        <TitleContainer>
          <Sup>{sup}</Sup>
          <Title>{title}</Title>
        </TitleContainer>
        <Text>{text}</Text>
        <Authors>
          <Link
            href={
              tenant && tenant.key
                ? `https://www.${tenant.key}.ch/author/${72813598}/erwan-le-bec`
                : ''
            }
          >
            Erwan Le Bec
          </Link>
          ,{' '}
          <Link
            href={
              tenant && tenant.key
                ? `https://www.${tenant.key}.ch/author/${19589557}/olaf-konig`
                : ''
            }
          >
            Olaf König
          </Link>
          ,{' '}
          <Link
            href={
              tenant && tenant.key
                ? `https://www.${
                    tenant.key
                  }.ch/author/${30694044}/mathieu-rudaz`
                : ''
            }
          >
            Mathieu Rudaz
          </Link>
        </Authors>
        <Date>Publié le 25 février 2023</Date>
      </TextWidth>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  text-align: center;
  background: linear-gradient(
    180deg,
    rgba(92, 93, 95, 1) 90%,
    rgba(92, 93, 95, 0) 100%
  );
  color: white;
  margin-bottom: -100px;
  z-index: 1;
`

const TitleContainer = styled.h2`
  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    margin-bottom: 1.2rem;
    font-size: 3.6rem;
    line-height: 4rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    margin-bottom: 1.2rem;
    font-size: 4.9rem;
    line-height: 5.2rem;
  }
`

const Title = styled.span`
  font-family: var(--font-source);
  font-weight: 600;
  display: block;
`

const Text = styled.h3`
  font-family: var(--font-sans-serif);
  font-weight: 400;
  -webkit-font-smoothing: antialiased;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1.8rem;
    line-height: 2.7rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 2rem;
    line-height: 2.9rem;
  }
`

const Sup = styled.span`
  display: inline-block;
  min-width: 85%;
  margin-bottom: 0.8rem;
  color: white;
  font-size: 1.5rem;
  font-family: var(--font-sans-serif);
  line-height: 2rem;

  &:before {
    display: inline-block;
    margin-right: 0.6rem;
    padding: 0.2rem 0.6rem;
    color: rgba(92, 93, 95);
    font-weight: 700;
    font-size: 1.2rem;
    font-family: var(--font-sans-serif);
    line-height: 1.5rem;
    letter-spacing: 0.025rem;
    white-space: nowrap;
    background-color: #ffffff;
    content: 'Abo';
  }
`

const Authors = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.2rem;
  line-height: 1.2;
  margin-bottom: 1rem;
`

const Link = styled.a`
  color: white;
  text-decoration: underline;
`

const Date = styled.div`
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  opacity: 0.5;
  line-height: 1.2;
`

export default Header
